import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Input, Row} from 'reactstrap';
import {getDatePickerProps, numberWithCommas, stringToNumber} from "../helpers/Utils";
import {composeValidators, mustBeInteger, mustBeNumber, mustBePositive, required} from "../helpers/Validators";
import {NotificationManager} from "../components/common/react-notifications";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {baseTokenSymbol} from "../constants/configs";
import FieldError from "../components/FieldError";
import TextField from '../components/TextField';
import JalaliUtils from "@date-io/jalaali";
import MomentUtils from "@date-io/moment";
import fa_IR from "../constants/locales";
import i18n from "../services/i18n";
import Api from "../services/Api";
import Select from "react-select";
import moment from "moment";

class ZarinpalTransferForm extends React.Component {
  constructor(props) {
    super(props);
    this.typeOptions = [
      {label: "ONCE", value: "ONCE"},
      {label: "DAILY", value: "DAILY"},
      // {label: "NOW", value: "NOW"},
    ];
    this.feeOptions = [
      {label: "PERCENTAGE", value: "PERCENTAGE"},
      {label: "FIX_VALUE", value: "FIX_VALUE"},
    ];
    this.quantityOptions = [
      {label: "PERCENTAGE", value: "PERCENTAGE"},
      {label: "FIX_VALUE", value: "FIX_VALUE"},
    ];
  }

  onSubmit = async values => {
    const {t, userId, afterSubmit} = this.props;
    const {source, expiresAt, feePolicyType, fee, transferPolicyType, quantity, amount, max, terminalId} = values;
    try {
      await Api.invoke('POST', '/v2/admin-ui/transfers/jobs', {
        userId,
        source,
        token: baseTokenSymbol,
        expiredAt: moment(expiresAt).toISOString(),
        sourceInfo: {
          terminal: {
            id: terminalId.value,
          },
        },
        transferPolice: {
          type: transferPolicyType.value,
          quantity: quantity.value,
          amount: Number(amount),
          ...(max ? {maxAmountValue: Number(max)} : null),
        },
        feePolice: {
          quantity: feePolicyType.value,
          amount: Number(fee),
        },
      });
      NotificationManager.success(t('Transfer request submitted successfully'), t('Message'));
      ModalManager.close({isOpen: false});
      afterSubmit();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  SelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      placeholder={this.props.t('Select')}
    />
  );


  render() {
    const {t, balances} = this.props;
    return(
      <FinalForm
        onSubmit={this.onSubmit}
        initialValues={{
          source: 'ZARINPAL',
        }}
        render={({handleSubmit, submitting, hasValidationErrors, pristine, values}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row className="mb-2">
                <Col>
                  <TextField
                    item={{
                      name: 'source',
                      i18n: t('Source'),
                      type: 'text',
                      disabled: true,
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <span>{t('Gateway')}<span className="required">*</span></span>
                  <Field
                    name="terminalId"
                    component={this.SelectAdapter}
                    options={balances.map(({terminal}) => ({label: terminal.name, value: terminal.id}))}
                    validate={required}
                  />
                  <FieldError name='terminalId'/>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <span>{t('Transfer policy')}<span className="required">*</span></span>
                  <Field
                    name="transferPolicyType"
                    component={this.SelectAdapter}
                    options={this.typeOptions}
                    validate={required}
                  />
                  <FieldError name='transferPolicyType'/>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <span>{t('Amount policy')}<span className="required">*</span></span>
                  <Field
                    name="quantity"
                    component={this.SelectAdapter}
                    options={this.quantityOptions}
                    validate={required}
                  />
                  <FieldError name='quantity'/>
                </Col>
              </Row>
              {!!values.quantity && values.quantity.value === "PERCENTAGE" &&
                <Row className="mb-3">
                  <Col>
                    <Field name="amount" validate={composeValidators(required, mustBeNumber, mustBePositive)}>
                      {({input}) => (
                        <div>
                          <span>{`${t('Amount')} (${t('Percent')})`}<span className="required">*</span></span>
                          <Input
                            {...input}
                            value={numberWithCommas(input.value)}
                            onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                          />
                          <FieldError name="amount"/>
                        </div>
                      )}
                    </Field>
                  </Col>
                </Row>
              }
              {!!values.quantity && values.quantity.value === "FIX_VALUE" &&
                <Row className="mb-3">
                  <Col>
                    <Field name="amount" validate={composeValidators(required, mustBeNumber, mustBePositive, mustBeInteger)}>
                      {({input}) => (
                        <div>
                          <span>{`${t('Amount')} (${t(baseTokenSymbol)})`}<span className="required">*</span></span>
                          <Input
                            {...input}
                            value={numberWithCommas(input.value)}
                            onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                          />
                          <FieldError name="amount"/>
                        </div>
                      )}
                    </Field>
                  </Col>
                </Row>
              }
              {!!values.quantity && values.quantity.value === "PERCENTAGE" &&
                <Row className="mb-3">
                  <Col>
                    <Field name="max" validate={composeValidators(required, mustBeNumber, mustBePositive, mustBeInteger)}>
                      {({input}) => (
                        <div>
                          <span>{`${t('Max amount')} (${t(baseTokenSymbol)})`}</span>
                          <Input
                            {...input}
                            value={numberWithCommas(input.value)}
                            onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                          />
                          <FieldError name="max"/>
                        </div>
                      )}
                    </Field>
                  </Col>
                </Row>
              }
              <Row className="mb-3">
                <Col>
                  <span>{t('Fee policy')}<span className="required">*</span></span>
                  <Field
                    name="feePolicyType"
                    component={this.SelectAdapter}
                    options={this.feeOptions}
                    validate={required}
                  />
                  <FieldError name='feePolicyType'/>
                </Col>
              </Row>
              {!!values.feePolicyType && values.feePolicyType.value === "PERCENTAGE" &&
                <Row className="mb-3">
                  <Col>
                    <Field name="fee" validate={composeValidators(required, mustBeNumber, mustBePositive)}>
                      {({input}) => (
                        <div>
                          <span>{`${t('Fee')} (${t('Percent')})`}<span className="required">*</span></span>
                          <Input
                            {...input}
                            value={numberWithCommas(input.value)}
                            onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                          />
                          <FieldError name="fee"/>
                        </div>
                      )}
                    </Field>
                  </Col>
                </Row>
              }
              {!!values.feePolicyType && values.feePolicyType.value === "FIX_VALUE" &&
                <Row className="mb-3">
                  <Col>
                    <Field name="fee" validate={composeValidators(required, mustBeNumber, mustBePositive, mustBeInteger)}>
                      {({input}) => (
                        <div>
                          <span>{`${t('Fee')} (${t(baseTokenSymbol)})`}<span className="required">*</span></span>
                          <Input
                            {...input}
                            value={numberWithCommas(input.value)}
                            onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                          />
                          <FieldError name="fee"/>
                        </div>
                      )}
                    </Field>
                  </Col>
                </Row>
              }
              <Row className="mb-4">
                <Col>
                  <span>{t('Expiration Date')}<span className="required">*</span></span>
                  <Field name="expiresAt" validate={required}>
                    {({input}) => (
                      <MuiPickersUtilsProvider
                        utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
                        locale={i18n.language}>
                        <DateTimePicker
                          {...getDatePickerProps()}
                          minDate={moment()}
                          maxDate={undefined}
                          value={input.value ? input.value : null}
                          onChange={date => {
                            if (moment(date) >= moment()) {
                              input.onChange(date);
                            } else {
                              alert(t("The selected time must be ahead of the current time."));
                            }
                          }}
                          TextFieldComponent={props =>
                            <Input
                              style={{width: '100%'}}
                              placeholder={t('Select')}
                              {...props}
                            />
                          }
                        />
                      </MuiPickersUtilsProvider>
                    )}
                  </Field>
                </Col>
              </Row>
              <Row className='mt-5'>
                <Col>
                  <LoaderButton
                    color="success"
                    className="text-center"
                    loading={submitting}
                    onClick={handleSubmit}
                    style={{minWidth: '100px'}}
                    disabled={pristine || hasValidationErrors || submitting}>
                    {t('Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(ZarinpalTransferForm);
